import Swiper from "swiper/bundle";

const iconTextSlider = document.querySelector(".multiple-column-image-slider");

if (iconTextSlider) {
  const swiper = new Swiper(iconTextSlider, {
    direction: "horizontal",
    loop: false,
    centeredSlides: false,
    slidesPerView: 1,
    simulateTouch: true,               // enable swiping
    grabCursor: true,
    touchAngle: 45,

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 26,
      },
      400: {
        slidesPerView: 1,
        spaceBetween: 26,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 26,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 26,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 26,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 26,
      },
    },
  });
}